import React from 'react';
import MuiTableHead, { type TableHeadProps } from '@mui/material/TableHead';
import type { TableRowProps } from '@mui/material/TableRow';
import type { TableCellProps } from '@mui/material/TableCell';

import TableRow from 'src/components/table/TableRow';
import TableCell from 'src/components/table/TableCell';

type HeaderProps = TableHeadProps & {
    rowProps?: TableRowProps;
};

export function TableHeader({
    children,
    rowProps,
    ...props
}: HeaderProps) {
    return (
        <MuiTableHead {...props}>
            <TableRow {...rowProps}>
                {children}
            </TableRow>
        </MuiTableHead>
    );
}

export function TableHeaderCell(props: TableCellProps) {
    return <TableCell component="th" {...props} />;
}

export default TableHeader;
